export default "__VITE_ASSET__KaITN428__"